<form [formGroup]="form">
    <ng-container [ngSwitch]="pageNumber">
        <div *ngSwitchCase="1">
            <div class="dialog-header">
                <span class="title">{{ 'aumico_create_project_dialog_select_company_title' | i18next }}</span>
                <span
                    hamIconShapes
                    class="close"
                    icon="assets/hamIcons/x.svg"
                    [variant]="'transparent'"
                    [size]="'xs'"
                    (click)="onCancel()"
                >
                </span>
            </div>
            <div>
                <span class="description">
                    {{ 'aumico_create_project_dialog_select_company_description' | i18next }}
                </span>
                <div class="input">
                    <input
                        hamSearchDropDown
                        [options]="companiesList"
                        [optionKeys]="['name']"
                        returnKey="_id"
                        [label]="'aumico_create_project_dialog_select_company_input_title' | i18next"
                        [returnObject]="true"
                        [placeholder]="'aumico_create_project_dialog_select_company_input_placeholder' | i18next"
                        [formControl]="form.controls['company']"
                        [multiple]="false"
                        class="searchuserinput"
                        #searchUserInput
                        [disabled]="!!company"
                    />
                </div>
            </div>
            <div class="footer">
                <div class="question-number">
                    {{ pageNumber }} {{ 'aumico_create_project_dialog_of' | i18next }} {{ totalNumberOfPages }}
                </div>
                <div>
                    <ham-button class="next-button" type="submit" size="xs" outline="true" (buttonClick)="onCancel()">
                        {{ 'aumico_create_project_dialog_cancel_button' | i18next }}
                    </ham-button>
                    <ham-button
                        class="next-button"
                        type="submit"
                        size="xs"
                        [disabled]="!form.controls['company'].valid"
                        (buttonClick)="next()"
                    >
                        {{ 'aumico_create_project_dialog_next_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="2">
            <div class="dialog-header">
                <span class="title">{{ 'aumico_create_project_dialog_select_report_type' | i18next }}</span>
                <span
                    hamIconShapes
                    class="close"
                    icon="assets/hamIcons/x.svg"
                    [variant]="'transparent'"
                    [size]="'xs'"
                    (click)="onCancel()"
                >
                </span>
            </div>
            <div>
                <div class="input">
                    <input
                        hamSearchDropDown
                        [options]="reportTypes"
                        [optionKeys]="['name']"
                        returnKey="id"
                        [label]="'aumico_create_project_dialog_select_report_type_description' | i18next"
                        [returnObject]="true"
                        [placeholder]="'aumico_create_project_dialog_select_report_type_input_placeholder' | i18next"
                        [formControl]="form.controls['reportType']"
                        [multiple]="false"
                        class="searchuserinput"
                        #searchUserInput
                    />
                </div>
            </div>
            <div class="footer">
                <div class="question-number">
                    {{ pageNumber }} {{ 'aumico_create_project_dialog_of' | i18next }} {{ totalNumberOfPages }}
                </div>
                <div>
                    <ham-button class="next-button" type="submit" size="xs" outline="true" (buttonClick)="onCancel()">
                        {{ 'aumico_create_project_dialog_cancel_button' | i18next }}
                    </ham-button>
                    <ham-button
                        class="next-button"
                        type="submit"
                        size="xs"
                        [disabled]="!form.controls['reportType'].valid"
                        (buttonClick)="next()"
                    >
                        {{ 'aumico_create_project_dialog_next_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>

        <div *ngSwitchCase="3">
            <div class="dialog-header">
                <span class="title">{{
                    'aumico_create_project_dialog_select_balance_sheet_date_title' | i18next
                }}</span>
                <span
                    hamIconShapes
                    class="close"
                    icon="assets/hamIcons/x.svg"
                    [variant]="'transparent'"
                    [size]="'xs'"
                    (click)="onCancel()"
                >
                </span>
            </div>
            <div>
                <span class="description">
                    {{ 'aumico_create_project_dialog_select_balance_sheet_date_description' | i18next }}
                </span>
                <div class="input">
                    <input
                        hamInput
                        #dateButtonWrapper
                        [suffixIcon]="'/assets/hamIcons/calendar-day-outline.svg'"
                        [label]="'aumico_create_project_dialog_select_balance_sheet_date_input_title' | i18next"
                        [placeholder]="
                            'aumico_create_project_dialog_select_balance_sheet_date_input_placeholder' | i18next
                        "
                        [value]="balanceSheetDateInput"
                        (input)="balanceSheetDateInput = $event.target.value"
                        (click)="openDateFlyout(dateButtonWrapper)"
                    />

                    <span
                        class="menu-flyout"
                        hamFlyout
                        *ngIf="dateFlyoutOpened"
                        [position]="flyoutPosition"
                        (closeFlyout)="closeDateFlyout()"
                    >
                        <div class="flyout-content">
                            <div class="custom-datepicker-wrapper">
                                <mat-calendar
                                    [selected]="calendarSelectedDate"
                                    [startAt]="calendarSelectedDate"
                                    (selectedChange)="updateDate($event)"
                                ></mat-calendar>

                                <div class="datepicker-actions">
                                    <ham-button variant="teal" size="sm" (click)="select3112minus1year()">{{
                                        previousYear | date : 'dd.MM.yy'
                                    }}</ham-button>

                                    <ham-button variant="white" size="sm" (click)="select3112thisYear()">{{
                                        currentYear | date : 'dd.MM.yy'
                                    }}</ham-button>
                                </div>
                            </div>
                        </div>
                    </span>
                    <span class="error-state" *ngIf="InvalidDateState">
                        {{ 'aumico_create_project_invalid_date' | i18next }}
                    </span>
                </div>
            </div>
            <div class="footer">
                <div class="question-number">
                    {{ pageNumber }} {{ 'aumico_create_project_dialog_of' | i18next }} {{ totalNumberOfPages }}
                </div>
                <div>
                    <ham-button type="submit" outline="true" size="xs" (buttonClick)="goBack()">
                        {{ 'aumico_create_project_dialog_back_button' | i18next }}
                    </ham-button>
                    <ham-button class="next-button" type="submit" size="xs" (buttonClick)="submit()">
                        {{ 'aumico_create_project_dialog_submit_button' | i18next }}
                    </ham-button>
                </div>
            </div>
        </div>
    </ng-container>
</form>
